import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: 15,
    right: 25
  },
  listRoot: {
    width: 330,
    backgroundColor: theme.palette.common.white
  },
  progress: {
    position: 'absolute',
    left: 14,
    top: 40,
    width: 24,
    height: 2
  },
  header: {
    backgroundColor: theme.palette.grey[200]
  },
}))

export {
  useStyles
}